import React from 'react';
import { ICrmPerson } from 'services/CrmApi/types/DirectoryEntry';
import { formatDateTimeDisplayWithoutOffset } from 'utils';
import { HidingTextTooltip } from 'ui/Tooltip/HidingTextTooltip';

export interface IUserDateProps {
  user?: ICrmPerson | null;
  date?: string | null;
  text: string;
  position?: 'horizontal' | 'vertical';
}

export const UserDate: React.FC<IUserDateProps> = ({ user, date, text, position = 'horizontal' }) => {
  if (!user || !date) {
    return null;
  }

  const createdBy = [
    user.firstName,
    user.lastName
  ].filter(Boolean).join(' ');
  const createdAt = date ? formatDateTimeDisplayWithoutOffset(date) : '';

  const userElement = (
    <HidingTextTooltip
      tooltipContent={user.email}
      position="bottom"
      tooltipContentClassname="pt-[1px] px-[5px] pb-[3px]"
    >
      <span className="underline">{createdBy}</span>
    </HidingTextTooltip>
  )

  if (position === 'horizontal') {
    return (
      <p className="flex items-center created-by m-0 font-pt-sans text-[13px] tracking-[0.52px] text-gray-100">
        {text}&nbsp;{userElement},&nbsp;{createdAt}
      </p>
    );
  }

  return (
    <>
      <p className="flex items-center created-by m-0 font-pt-sans text-[13px] tracking-[0.52px] text-gray-100">
        {text}&nbsp;{userElement},
      </p>
      <p className="flex items-center created-date m-0 font-pt-sans text-[13px] tracking-[0.52px] text-gray-100">
        {createdAt}
      </p>
    </>
  );
}
